'use client';

import {useQueryClient} from '@tanstack/react-query';
import {FC, memo, useInsertionEffect} from 'react';

export let QueryClient: ReturnType<typeof useQueryClient>;

export const QueryClientExposer: FC = memo(function QueryClientExposer() {
    const queryClient = useQueryClient();

    useInsertionEffect(() => {
        QueryClient = queryClient;
    }, [queryClient]);

    return null;
});
